'use strict';

require('core-js/fn/object/assign');
require('core-js/fn/object/values');
require('./common/srcdoc');



// WEBPACK FOOTER //
// ./src/polyfills.js